import React from 'react'
import Images from '../../../components/Images/Images';

function ModelVideo(_props){

    let _model = _props._model;
    let body =  _model.data.body;

    let found = false;
    let item_count = 0;
    let video_banner = null;

    while (!found && item_count<body.length)
    {
        let item = body[item_count];
        if(item.__typename==="PrismicModelBodyBannerVideo")
        {
            found = true;
            video_banner = item.primary;
        }
        item_count++;
    }
    return ( found ?

        <div className="detail_video model_detail_section">
            <div className="detail_video_stage">
                <Images 
                   sources={{
                        mb: { url: video_banner.banner_image_xs.url },
                        sm: { url: video_banner.banner_image_sm.url },
                        md: { url: video_banner.banner_image_sm.url },
                        lg: { url: video_banner.banner_image_xlg.url },
                        url: video_banner.banner_image_xlg.url
                    }}
                    alt="calorex modelo banner"
                />
            </div>
        </div> : null
    )
}
export default ModelVideo
